export default __webpack_public_path__ + "static/media/address.1e8cbdd5.svg";